import React from "react";

import { ButtonProps } from "@models/shared/shared.model";
import { mergeClassNames } from "@utils/common.utils";

const Button: React.FC<ButtonProps> = ({
  className = "",
  disabled,
  label,
  onClick,
  testid = "sharedButtonTest",
}) => {
  return (
    <button
      className={mergeClassNames("btn fg-btn", className)}
      onClick={onClick}
      disabled={disabled}
      data-testid={testid}
    >
      {label}
    </button>
  );
};

export default Button;
